import { getLevelInfo } from '@/constants/levels';
import { cn } from '@/lib/cn';

interface LevelBadgeProps {
  level: number;
  size?: 'sm' | 'md';
  className?: string;
  onClick?: () => void;
}

/**
 * Lv.N 형태의 레벨 뱃지.
 * - onClick 전달 시 버튼 커서 + hover 강조 (MyPage 에서 레벨 설명 모달 트리거용)
 */
export function LevelBadge({ level, size = 'sm', className, onClick }: LevelBadgeProps) {
  const info = getLevelInfo(level);
  const content = (
    <span
      className={cn(
        'inline-flex items-center font-semibold',
        size === 'sm' ? 'text-xs' : 'text-sm',
        className,
      )}
      style={{ color: info.color }}
    >
      {info.label}
    </span>
  );
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className="hover:opacity-80 transition-opacity">
        {content}
      </button>
    );
  }
  return content;
}
